export const NAME = 'flatHandGathering';